import { graphql } from '@generated/gql';

export const SEARCH_USERS_FOR_RECON_FLAGS_GRID = graphql(`
  query searchUsersForReconFlagsGrid($input: UserSearchInput!) {
    searchUsers(input: $input) {
      users {
        id
        firstName
        lastName
        entityName
        primaryEmail
        accounts {
          id
        }
      }
    }
  }
`);

export const FETCH_FLAGS_FOR_GRID = graphql(`
  query fetchFlagsForGrid($input: FetchFlagsInputForGrid!) {
    fetchFlagsForGrid(input: $input) {
      flags {
        id
        objectId
        objectType
        type
        priority
        category
        message
        notes {
          text
          author
          authorId
          createdAt
        }
        details
        state
        createdAt
        firstSeenAt
        organization {
          id
        }
        account {
          id
          custodianAccountNumber
          user {
            id
            firstName
            lastName
            entityName
          }
        }
      }
      totalCount
    }
  }
`);

/** Org-scoped KPI aggregates for the reconciliation flags spotlight dashboard. */
export const FETCH_FLAG_KPIS = graphql(`
  query fetchFlagKPIs($organizationId: ObjectID!, $unresolvedBefore: GraphQLDateTime) {
    fetchFlagKPIs(organizationId: $organizationId, unresolvedBefore: $unresolvedBefore) {
      totalFlags
      unresolvedOverThreeDays
      typeCounts {
        flagType
        count
      }
    }
  }
`);

export const TRANSITION_FLAG = graphql(`
  mutation transitionFlag($input: TransitionFlagInput!) {
    transitionFlag(input: $input) {
      flag {
        id
      }
    }
  }
`);

/** Bulk state transitions for grid-backed reconciliation flags. */
export const BULK_TRANSITION_FLAGS_FOR_GRID = graphql(`
  mutation bulkTransitionFlagsForGrid($input: BulkTransitionFlagsInput!) {
    bulkTransitionFlagsForGrid(input: $input) {
      succeeded {
        id
        state
      }
      failed {
        flagId
        error
      }
    }
  }
`);

export const UPDATE_FLAG_NOTES = graphql(`
  mutation updateFlagNotes($input: UpdateFlagNotesInput!) {
    updateFlagNotes(input: $input) {
      flag {
        id
        notes {
          text
          author
          authorId
          createdAt
        }
      }
    }
  }
`);

export const FETCH_FLAG_TYPES = graphql(`
  query fetchFlagTypes {
    __type(name: "FlagTypes") {
      enumValues {
        name
      }
    }
  }
`);
